import cities from "../../data/citiesCodes";

const getDate = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate.toISOString();
}

const getCode = (label: any): string => {
    const finded = cities.find((c: any) => c.value === label);
    return finded ? finded.value : "";
}

const getSlices = (trip: any, travels: any, initialDepature: any, initialReturning: any) => {
    let totalSlices: any[] = [];
    switch (trip) {
        case "One-way":
         const oneSlice = [
                {
                    origin: getCode(travels[0].leavingFrom),
                    destination: getCode(travels[0].goingTo),
                    departure_date: travels[0].departureDate ? getDate(travels[0].departureDate) : null
                }
            ]
            totalSlices = oneSlice ;
            break;
            case "Multi-City":
                const multiSlices: any[]  = [];
                travels.map((t: any, i: any) => {
               //    initialDepature.setDate(initialDepature.getDate() + i);
                   const SingleSlice = {
                           origin: getCode(t.leavingFrom),
                           destination: getCode(t.goingTo),
                           departure_date: t.departureDate ? getDate(t.departureDate) : null
                       }
                       multiSlices.push(SingleSlice);
               });
               console.warn("slice from get slices before filter: ", multiSlices);
               let result = multiSlices.filter(d => (d.destination !== "" && d.origin !== ""));
               console.error("slice from get slices after filter: ", result);
       
               totalSlices = result;
            break;
            case "Round-trip":
             const roundSlices  = [
                    {
                        origin: getCode(travels[0].leavingFrom),
                        destination: getCode(travels[0].goingTo),
                        departure_date: travels[0].departureDate ? getDate(travels[0].departureDate) : null
                    },
                    {
                        origin: getCode(travels[0].goingTo),
                        destination: getCode(travels[0].leavingFrom),
                        departure_date: travels[0].returnDate ? getDate(travels[0].returnDate) : null
                    }
                ]
                totalSlices = roundSlices;
            break;
    
        default:
            totalSlices = [];
            break;
    }
    return totalSlices;

}

export default getSlices;